// extracted by mini-css-extract-plugin
export default {"dialog-assignment-group__inner":"dialog-assignment-group__inner--HcmpW","dialogAssignmentGroupInner":"dialog-assignment-group__inner--HcmpW"};